/**
 * ConsultExpertDecoIcon — sanitized from `assets/newSvg/consult-expert-deco.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function ConsultExpertDecoIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M14.4472,1.10555 C14.9412,1.35254 15.1414,1.95321 14.8944,2.44719 L14.118,3.99997 L18,3.99997 C19.1046,3.99997 20,4.89541 20,5.99998 L20,20 C20,21.1045 19.1046,22 18,22 L6,22 C4.89543,22 4,21.1045 4,20 L4,5.99998 C4,4.89541 4.89543,3.99997 6,3.99997 L9.88197,3.99997 L9.10557,2.44719 C8.85858,1.95321 9.05881,1.35254 9.55279,1.10555 C10.0468,0.858558 10.6474,1.05878 10.8944,1.55276 L12,3.76391 L13.1056,1.55276 C13.3526,1.05878 13.9532,0.858558 14.4472,1.10555 Z M13.5,14 L10.5,14 C9.1745184,14 8.08996147,15.0315469 8.00531769,16.3356256 L8,16.5 L8,17 C8,17.5523 8.44772,18 9,18 C9.51283143,18 9.93550653,17.613973 9.9932722,17.1166239 L10,17 L10,16.5 C10,16.2544889 10.1769086,16.0503802 10.4101355,16.0080538 L10.5,16 L13.5,16 C13.7454222,16 13.9496,16.1768296 13.9919429,16.4101092 L14,16.5 L14,17 C14,17.5523 14.4477,18 15,18 C15.51285,18 15.9355092,17.613973 15.9932725,17.1166239 L16,17 L16,16.5 C16,15.174528 14.9684531,14.0899622 13.6643744,14.0053177 L13.5,14 Z M12,8.99998 C10.8954,8.99998 10,9.89541 10,11 C10,12.1045 10.8954,13 12,13 C13.1046,13 14,12.1045 14,11 C14,9.89541 13.1046,8.99998 12,8.99998 Z"
        fill={color}
      />
    </Svg>
  );
}

export default ConsultExpertDecoIcon;
